import { render, staticRenderFns } from "./Suositus.vue?vue&type=template&id=4c7b462c&"
import script from "./Suositus.vue?vue&type=script&lang=js&"
export * from "./Suositus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/wordpress/Kaypa-hoito/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7b462c')) {
      api.createRecord('4c7b462c', component.options)
    } else {
      api.reload('4c7b462c', component.options)
    }
    module.hot.accept("./Suositus.vue?vue&type=template&id=4c7b462c&", function () {
      api.rerender('4c7b462c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/Suositus.vue"
export default component.exports